<template>
  <div
    style="height: 100%"
    class="blue-grey lighten-5"
    id="inspire"
  >
    <v-app-bar
      height="78"
      app
      dark
    >
      <v-toolbar-title class="">
        <!-- @click="$router.push(modosMesas[0].enlace)" -->

        <v-btn
          @click="
            $router.push(modosMesas[0].enlace);
          tab = 1;
          "
          class="px-0 py-8 fe--inicio-btn"
          max-width="100%"
        >
          <v-img
            class="pa-0"
            src="/img/logoFunEats.svg"
            lazy-src="/img/logoFunEats.svg"
            contain
            width="150"
            height="30"
          ></v-img>
        </v-btn>
      </v-toolbar-title>
      <v-divider
        class="mx-4"
        inset
        vertical
      ></v-divider>
      <v-btn
        class="rounded-lg"
        large
        outlined
        color="primary"
        @click="$store.commit('usuarios/setEleccionUsuarioDialog', true)"
      >
        <v-icon left>mdi-account-check</v-icon>
        {{ $store.state.usuarios.usuarioActualObj.nombre }}
      </v-btn>
      <!-- Aquí iba la hora -->
      <v-btn
        class="rounded-lg mx-4"
        large
        outlined
        color="primary"
        @click="dialogoSoporte = true"
      >
        <v-icon>mdi-whatsapp</v-icon>
        <!--<span v-if="!$vuetify.breakpoint.smAndDown"> SOPORTE </span>-->
      </v-btn>
      <!-- <v-btn
        class="rounded-lg mx-4"
        large
        outlined
        color="primary"
        @click="dialogoManual = true"
      >
        <v-icon>mdi-file-pdf-box</v-icon> -->
      <!--<span v-if="!$vuetify.breakpoint.smAndDown"> MANUAL </span>
      </v-btn>-->
      <v-btn
        v-if="totalZ"
        class="rounded-lg mr-4"
        large
        outlined
        color="primary"
        @click="cerrarDia()"
      >
        <!--<span class="mr-3">{{ totalZ }}</span>-->
        <v-icon>mdi-currency-eur</v-icon>
        <!--<span v-if="!$vuetify.breakpoint.smAndDown"> MANUAL </span>-->
      </v-btn>
      <!--<span class="mx-2">{{ $store.state.contable.numerosContables }}</span>
      -
      <span class="mx-2">{{ $store.state.pedidos.siguienteNumRest }}</span
      >-->

      <!-- <v-card>
					<v-list-item-group v-model="usuarioSeleccionado">
						<v-list-item
							color="success"
							v-for="usuario in $store.getters['usuarios/getUsuariosListado']"
							:key="usuario.id"
							:value="usuario.id"
						>
							<v-list-item-content>
								<v-list-item-title class="title">{{
									usuario.nombre
								}}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
				</v-card> -->

      <v-spacer />
      <span
        v-if="!!$store.state.directorio.directorioMatrizObj"
        class="font-weight-black body-2 text-uppercase d-none d-md-flex"
      >{{ $store.state.directorio.directorioMatrizObj.nombre }}
      </span>
      <span
        v-else-if="!!$store.state.restauranteObj.restauranteEmpresa"
        class="font-weight-black body-2 text-uppercase d-none d-md-flex"
      >{{ $store.state.restauranteObj.nombre }}
      </span>
      <span
        v-else
        class="font-weight-black body-2 text-uppercase d-none d-md-flex"
      >{{ negocioObj.nombre }} - {{ nombre }}</span>
      <span
        v-if="!!$store.state.restauranteObj.descripcionRelevante && $store.state.restauranteObj.descripcionRelevante.es"
        class="ml-1 font-weight-black text-caption text-uppercase d-none d-md-flex"
      >({{ negocioObj.descripcionRelevante.es }})</span>
      <v-divider
        class="mx-4"
        inset
        vertical
      ></v-divider>

      <v-btn
        v-if="$store.state.online"
        large
        class="rounded-lg"
        outlined
        color="primary"
        @click="menuLateral = !menuLateral"
      >
        On
        <v-icon
          v-if="$store.state.onlineComputadora"
          right
          color="primary"
        >mdi-link-variant</v-icon>
        <v-icon
          v-else
          color="red"
          right
        >mdi-link-variant-off</v-icon>
        <v-icon
          v-if="$store.getters.cuenta.marcaConectado"
          right
        >mdi-web</v-icon>
        <v-icon right>mdi-menu-down</v-icon>
      </v-btn>
      <v-btn
        v-else
        large
        class="rounded-lg"
        outlined
        color="red"
        @click="menuLateral = !menuLateral"
      >
        Off
        <v-icon
          v-if="$store.state.onlineComputadora"
          right
          color="primary"
        >mdi-link-variant</v-icon>
        <v-icon
          v-else
          color="red"
          right
        >mdi-link-variant-off</v-icon>
        <v-icon
          v-if="$store.getters.cuenta.marcaConectado"
          right
        >mdi-web</v-icon>
      </v-btn>

      <v-btn
        v-if="$store.state.cashguardPosible"
        large
        class="ml-3 rounded-lg"
        outlined
        :color="$store.getters['usarCashGuard'] ? 'primary' : 'orange'"
        @click="abrirCashguard"
      >
        <v-icon>mdi-desktop-classic</v-icon>
      </v-btn>

      <!-- <v-divider class="mx-4" inset vertical></v-divider>
      <v-btn large class="rounded-lg" color="red" dark @click="logout">
        <v-icon size="34" dark>mdi-power</v-icon>
      </v-btn> -->
    </v-app-bar>
    <v-sheet
      class="subheader-nav--sticky"
      color="primary"
    >
      <div class="d-flex elevation-3">
        <v-tabs
          v-model="tab"
          background-color="transparent"
          class="modos-tabs"
          show-arrows
          center-active
          slider-size="8"
          slider-color="teal lighten-1"
          active-class="font-weight-black teal lighten-4"
          slider
          height="78"
          prev-icon="mdi-chevron-left"
          next-icon="mdi-chevron-right"
          style="max-width: calc(100% - 78px)"
        >
          <v-tab
            class="black--text d-none px-0"
            @click="$router.push('/dashboard')"
          >INICIO</v-tab>
          <v-tab
            v-for="(modoMesa, i) in modosMesas"
            :key="i"
            class="px-0 justify-center"
          >
            <router-link
              :to="modoMesa.enlace"
              class="black--text px-2"
            >
              <span>
                {{ modoMesa.nombre }}
              </span>
            </router-link>
          </v-tab>
        </v-tabs>
        <v-spacer />
        <v-divider vertical></v-divider>
        <v-menu
          bottom
          left
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              width="78"
              height="78"
              :style="!$store.state.tab ? 'background-color: #b2dfdb' : ''"
            >
              <v-icon size="30">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list light>
            <v-list-item-group color="secundary">
              <v-list-item
                class="py-2"
                @click="ultimopedido"
              >
                <v-list-item-icon>
                  <v-icon color="black"> mdi-receipt </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Último pedido cobrado</v-list-item-title>
                </v-list-item-content>

              </v-list-item>
              <v-list-item
                class="py-2"
                @click="abrirBuscarPedido"
              >
                <v-list-item-icon>
                  <v-icon color="black"> mdi-magnify </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Buscar pedido</v-list-item-title>
                </v-list-item-content>

              </v-list-item>
              <v-list-item
                class="py-2"
                @click="$router.push('/busquedapedidos')"
              >
                <v-list-item-icon>
                  <v-icon color="black"> mdi-format-list-bulleted </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Todos los pedidos del día</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                class="py-2"
                @click="$router.push('/dashboard')"
              >
                <v-list-item-icon>
                  <v-icon color="black"> mdi-cog </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Configuración</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </div>
    </v-sheet>

    <v-main>
      <v-container
        fluid
        class
      >
        <router-view />
      </v-container>
    </v-main>

    <v-footer
      height="78"
      dark
      app
      class="pa-0"
    >
      <footerComponent />
    </v-footer>
    <notificacion-dialog id="notificacines" />
    <v-dialog
      :fullscreen="$vuetify.breakpoint.smAndDown"
      overlay-opacity="0.90"
      :content-class="$vuetify.breakpoint.mdAndUp
        ? 'mt-n4 dialogo--custom-fs elevation-0 dialogo--no-fs'
        : 'dialogo--custom-fs elevation-0 dialogo--no-fs'
        "
      id="tiempoForzadoCierre"
      v-model="tiempoForzadoCierreDialog"
      max-width="600px"
      scrollable
    >
      <v-card
        class="transparent"
        :class="$vuetify.breakpoint.mdAndUp ? '' : 'rounded-0'"
      >
        <v-card-title
          v-if="$vuetify.breakpoint.mdAndUp"
          class="py-6 transparent"
        ><v-btn
            fab
            :height="$vuetify.breakpoint.smAndDown ? 48 : 88"
            :width="$vuetify.breakpoint.smAndDown ? 48 : 88"
            color="primary"
            @click="tiempoForzadoCierreDialog = false"
            absolute
            right
            :class="$vuetify.breakpoint.smAndDown ? 'mt-16' : 'mt-10 mr-n4'"
          ><v-icon
              :size="$vuetify.breakpoint.smAndDown ? 36 : 54"
              color="black"
            >mdi-close</v-icon></v-btn></v-card-title>
        <v-card-title
          :class="$vuetify.breakpoint.smAndDown
            ? 'caption'
            : $vuetify.breakpoint.mdAndDown
              ? 'title rounded-t-lg'
              : 'display-1 rounded-t-lg'
            "
          class="text--primary blue-grey lighten-5"
        >
          ¿Cuanto tiempo quiere cerrar
          {{
            tiempoForzadoCierreModo ? tiempoForzadoCierreModo.join(" y ") : ""
          }}?
          <v-spacer></v-spacer>
          <v-btn
            v-if="$vuetify.breakpoint.smAndDown"
            fab
            height="48"
            width="48"
            color="primary"
            @click="tiempoForzadoCierreDialog = false"
            absolute
            right
            class="mr-n2"
          ><v-icon
              size="36"
              color="black"
            >mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="rounded-b-lg pt-4 blue-grey lighten-5 border">
          <v-row
            align="center"
            class="white--text"
          >
            <v-col
              cols="6"
              md="3"
            >
              <v-card
                color="green"
                class="white--text text-center"
                @click="elegirTiempoCierre(15)"
                rounded="lg"
              >
                <v-responsive
                  :aspect-ratio="1.618"
                  class="align-center justify-center text-button"
                >
                  <div>15 min</div>
                </v-responsive>
              </v-card>
            </v-col>
            <v-col
              cols="6"
              md="3"
            >
              <v-card
                color="orange"
                class="white--text text-center"
                @click="elegirTiempoCierre(30)"
                rounded="lg"
              >
                <v-responsive
                  :aspect-ratio="1.618"
                  class="align-center justify-center text-button"
                >
                  <div>30 min</div>
                </v-responsive>
              </v-card>
            </v-col>
            <v-col
              cols="6"
              md="3"
            >
              <v-card
                color="red"
                class="white--text text-center"
                @click="elegirTiempoCierre(60)"
                rounded="lg"
              >
                <v-responsive
                  :aspect-ratio="1.618"
                  class="align-center justify-center text-button"
                >
                  <div>1 hora</div>
                </v-responsive>
              </v-card>
            </v-col>
            <v-col
              cols="6"
              md="3"
            >
              <v-card
                color="black"
                class="white--text text-center"
                @click="elegirTiempoCierre(60 * 4)"
                rounded="lg"
              >
                <v-responsive
                  :aspect-ratio="1.618"
                  class="align-center justify-center text-button"
                >
                  <div>4 horas</div>
                </v-responsive>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <eleccion-usuario-dialog />
    <eleccion-usuario-admin-acciones-dialog />
    <v-dialog
      :fullscreen="$vuetify.breakpoint.smAndDown"
      v-model="dialogoSoporte"
      max-width="400"
      overlay-opacity="0.90"
      content-class="elevation-0"
    >
      <v-card
        class="transparent"
        :rounded="$vuetify.breakpoint.smAndDown ? '0' : 'lg'"
      >
        <v-card-title class="white py-3 pr-3">
          <h2
            :class="$vuetify.breakpoint.smAndDown ? 'caption' : 'body-1'"
            class="font-weight-black"
          >
            Soporte
          </h2>
          <v-spacer />
          <v-btn
            fab
            :height="$vuetify.breakpoint.smAndDown ? 48 : 68"
            :width="$vuetify.breakpoint.smAndDown ? 48 : 68"
            color="primary"
            @click="dialogoSoporte = false"
            top
            right
          >
            <v-icon
              :size="$vuetify.breakpoint.smAndDown ? 36 : 44"
              color="black"
            >mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="blue-grey lighten-5 pt-4 rounded-b-lg">
          Escanea el siguiente código QR para contactar con nosotros.
          <div class="d-flex justify-center mt-8">
            <!-- <vue-qr text="https://vuetifyjs.com/en/components/alerts/" size="200"></vue-qr> -->
            <v-img
              src="/img/whatsappMewo.png"
              max-width="200"
              max-height="200"
            >
            </v-img>
          </div>

          <v-btn
            class="mt-6 black--text"
            x-large
            rounded
            color="primary"
            href="https://funeats.page.link/WoQJ"
            target="_blank"
            width="100%"
          >APP impresión</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.smAndDown"
      v-model="dialogoManual"
      max-width="400"
      overlay-opacity="0.90"
      content-class="elevation-0"
    >
      <v-card
        class="transparent"
        :rounded="$vuetify.breakpoint.smAndDown ? '0' : 'lg'"
      >
        <v-card-title class="white py-3 pr-3">
          <!-- <v-icon color="info" class="mr-4"> mdi-history </v-icon> -->
          <h2
            :class="$vuetify.breakpoint.smAndDown ? 'caption' : 'body-1'"
            class="font-weight-black"
          >
            Manual
          </h2>
          <v-spacer />
          <v-btn
            fab
            :height="$vuetify.breakpoint.smAndDown ? 48 : 68"
            :width="$vuetify.breakpoint.smAndDown ? 48 : 68"
            color="primary"
            @click="dialogoManual = false"
            top
            right
          >
            <v-icon
              :size="$vuetify.breakpoint.smAndDown ? 36 : 44"
              color="black"
            >mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="blue-grey lighten-5 pt-4 rounded-b-lg">
          Escanea el siguiente código QR para leer el manual, o pincha el botón
          para verlo en el TPV.
          <div class="d-flex justify-center mt-8">
            <vue-qr
              text="https://funeats.page.link/FETPV"
              :size="200"
            ></vue-qr>
          </div>
          <v-btn
            class="mt-6 black--text"
            x-large
            rounded
            color="primary"
            href="https://funeats.page.link/FETPV"
            target="_blank"
            width="100%"
          >Ver manual</v-btn>
          <v-btn
            class="mt-6 black--text"
            x-large
            rounded
            color="primary"
            href="https://funeats.page.link/WoQJ"
            target="_blank"
            width="100%"
          >APP impresión</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <v-btn
      v-if="$store.state.mostrarFabAdd"
      fab
      height="54"
      width="54"
      bottom
      left
      color="secondary"
      fixed
      @click="$store.commit('setMostrarTeclado', true)"
      ><v-icon size="54" color="black">mdi-keyboard</v-icon></v-btn
    > -->
    <template v-if="$store.state.mostrarFabAdd">
      <v-btn
        v-if="!$store.getters['cuenta'].cobrarSinProducto"
        fab
        height="108"
        width="108"
        bottom
        right
        color="primary"
        fixed
        @click="abrirDialogoAnadir = true"
      ><v-icon
          size="54"
          color="black"
        >mdi-plus</v-icon></v-btn>
      <v-btn
        v-else
        fab
        height="108"
        width="108"
        bottom
        right
        color="primary"
        fixed
        @click="cobrarSinProducto"
      ><v-icon
          size="54"
          color="black"
        >mdi-hand-coin</v-icon></v-btn></template>

    <cargando-lazy />
    <!--<generando-catalogo />-->
    <impresion />
    <contable />
    <cobrar-dialog />
    <internos-dialog />
    <productos-dialog />
    <cliente-dialog />
    <anadir-dialogo />
    <calendario-dialogo />
    <keyboard-completo-bottom />
    <v-navigation-drawer
      v-model="menuLateral"
      fixed
      right
      temporary
      width="440"
    >
      <v-list class="py-0">
        <v-list-item
          style="background-color: #455a64"
          dense
        >
          <v-list-item-content class="py-0">
            <v-list-item-title class="title white--text font-weight-black">
              Online
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action
            class="my-0"
            @click.stop="cambio(['domicilio', 'recoger'])"
          >
            <v-switch
              inset
              readonly
              :loading="estado.loading"
              v-model="estadoGeneral"
              color="white"
            ></v-switch>
          </v-list-item-action>
        </v-list-item>
        <v-row class="mb-0">
          <v-col
            cols="6"
            class="pt-6 pl-6"
          >
            <v-text-field
              class="cyan accent-1 font-weight-bold centered-input rounded-lg"
              readonly
              label="TIEMPO DOMICILIO"
              :value="tiempoDomicilio + ' min'"
              outlined
              hide-details
              dense
            ></v-text-field>
            <v-row
              class="mt-3"
              no-gutters
            >
              <v-col
                cols="6"
                class="pr-2"
              >
                <v-btn
                  dark
                  block
                  @click="sumarRestar('resta', 'reparto')"
                  class="rounded-lg"
                >
                  <v-icon size="34">mdi-minus</v-icon>
                </v-btn>
              </v-col>
              <v-col
                cols="6"
                class="pl-2"
              >
                <v-btn
                  dark
                  block
                  @click="sumarRestar('suma', 'reparto')"
                  class="rounded-lg"
                >
                  <v-icon size="34">mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-divider class="my-4"></v-divider>
            <v-text-field
              class="cyan accent-1 font-weight-bold centered-input rounded-lg"
              readonly
              label="TIEMPO RECOGIDA"
              :value="tiempoRecogida + ' min'"
              outlined
              hide-details
              dense
            ></v-text-field>
            <v-row
              class="mt-3"
              no-gutters
            >
              <v-col
                cols="6"
                class="pr-2"
              >
                <v-btn
                  dark
                  block
                  @click="sumarRestar('resta', 'recogida')"
                  class="rounded-lg"
                >
                  <v-icon size="34">mdi-minus</v-icon>
                </v-btn>
              </v-col>
              <v-col
                cols="6"
                class="pl-2"
              >
                <v-btn
                  dark
                  block
                  @click="sumarRestar('suma', 'recogida')"
                  class="rounded-lg"
                >
                  <v-icon size="34">mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="6">
            <v-list-item dense>
              <v-list-item-content>
                <v-list-item-title class="subtitle-1">DOMICILIO</v-list-item-title>
                <v-list-item-subtitle
                  v-for="(item, i) in horariosDomicilio"
                  class="text--primary"
                  :key="`${i}_domicilio`"
                >{{ item }}</v-list-item-subtitle>
                <h5
                  v-if="restObj.modoHorarioDomicilio == 'forzado_cierre' &&
                    restObj.modoHorarioDomicilioTiempo > 0
                    "
                  class="warning--text"
                >
                  Cerrado hasta {{ restObj.modoHorarioDomicilioTiempoMostrar }}
                </h5>
              </v-list-item-content>
              <v-list-item-action @click.stop="cambio(['domicilio'])">
                <v-switch
                  inset
                  readonly
                  :loading="estado.loading"
                  class="my-2"
                  v-model="estadoDomicilio"
                  color="blue-grey darken-2"
                ></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              class="mb-4"
              dense
            >
              <v-list-item-content>
                <v-list-item-title class="subtitle-1">RECOGER</v-list-item-title>
                <v-list-item-subtitle
                  v-for="(item, i) in horariosRecoger"
                  class="text--primary"
                  :key="`${i}_recoger`"
                >{{ item }}</v-list-item-subtitle>
                <h5
                  v-if="restObj.modoHorarioRecogerTiempo"
                  class="warning--text"
                >
                  Cerrado hasta {{ restObj.modoHorarioRecogerTiempoMostrar }}
                </h5>
              </v-list-item-content>
              <v-list-item-action @click.stop="cambio(['recoger'])">
                <v-switch
                  inset
                  readonly
                  :loading="estado.loading"
                  class="my-2"
                  v-model="estadoRecoger"
                  color="blue-grey darken-2"
                ></v-switch>
              </v-list-item-action>
            </v-list-item>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <v-container
          class=""
          fluid
          style="position: absolute; bottom: 0"
        >
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-btn
                @click="abrirCajon"
                :loading="loadingZ"
                color="primary black--text"
                x-large
                block
                class="rounded-lg"
              >Abrir cajón</v-btn>
            </v-col>
          </v-row>
          <v-row
            class="my-0"
            v-if="!$store.state.zcierre"
          >
            <v-col
              cols="12"
              class="pr-1"
            >
              <v-btn
                @click="imprimirz"
                :loading="loadingZ"
                dark
                x-large
                block
                class="rounded-lg mr-n2"
              >Imprimir Z</v-btn>
            </v-col>
            <v-col
              cols="2"
              class="pl-1"
            >
              <v-btn
                @click="imprimirzAyer"
                :loading="loadingZ"
                dark
                x-large
                block
                class="rounded-lg"
              >AYER</v-btn>
            </v-col>
          </v-row>
          <v-row
            class=""
            v-else
          >
            <v-col
              cols="6"
              class="pr-1"
            >
              <v-btn
                @click="imprimirz"
                :loading="loadingZ"
                dark
                x-large
                block
                class="rounded-lg"
              >Imprimir Z</v-btn>
            </v-col>
            <v-col
              cols="6"
              class="pl-1"
            >
              <v-btn
                :disabled="!$store.state.zcierre"
                @click="cerrarDia"
                :loading="loadingZ"
                dark
                x-large
                block
                class="rounded-lg"
              >Cerrar día</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              class="pt-0"
            >
              <v-btn
                @click="salidaDinero"
                dark
                x-large
                block
                class="rounded-lg"
              >Salida dinero</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-list>
    </v-navigation-drawer>
    <info-producto-dialogo />
    <z-cierre-inicio />
    <z-cierre-fin />
    <salida-dinero-dialog />
    <cashguard-dialog />
    <cashguard-bottom />
    <devolucion-dialog />
    <devolucion-confirmar-dialog />
    <buscar-pedido-dialog />
  </div>
</template>

<script>
import panelLateral from "@/components/panelLateral.vue";
import panelPedidosInternos from "@/components/pedidosInternos_panelLateral.vue";
import footerComponent from "@/components/footerComponent.vue";
import notificacionDialog from "@/components/NotificacionDialogo.vue";
import eleccionUsuarioDialog from "@/components/EleccionUsuarioDialog.vue";
import EleccionUsuarioAdminAccionesDialog from "@/components/EleccionUsuarioAdminAccionesDialog.vue";
import firebase from "firebase";
import cargandoLazy from "@/components/CargandoLazy.vue";
import GenerandoCatalogo from "@/components/GenerandoCatalogo.vue";
import Impresion from "@/components/Impresion.vue";
import Contable from "@/components/Contable.vue";
import CobrarDialog from "@/components/CobrarDialog.vue";
import ClienteDialog from "@/components/ClienteDialog.vue";
import anadirDialogo from "@/components/AnadirDialogo.vue";
import infoProductoDialogo from "@/components/InfoProductoDialogo.vue";
import { mapState, mapActions } from "vuex";
import { arrayHorariosRest } from "../utils/dias.utils.js";
import { mostrarIdioma, mostrarMoneda } from "@/utils/helper.utils.js";
import KeyboardCompletoBottom from "@/components/KeyboardCompletoBottom";
import calendarioDialogo from "@/components/CalendarioDialogo.vue";
import zCierreInicio from "@/components/ZCierreInicio.vue";
import zCierreFin from "@/components/ZCierreFin.vue";
import SalidaDineroDialog from "@/components/SalidaDineroDialog.vue";
import CashguardDialog from "@/components/CashguardDialog.vue";
import InternosDialog from "@/components/InternosDialog.vue";
import ProductosDialog from "@/components/ProductosDialog.vue";
import DevolucionDialog from "@/components/DevolucionDialog.vue";
import DevolucionConfirmarDialog from "@/components/DevolucionConfirmarDialog.vue";
import CashguardBottom from "@/components/CashguardBottom.vue";
import BuscarPedidoDialog from "@/components/BuscarPedidoDialog.vue";

import moment from "moment";
import VueQr from "vue-qr";
import { parDiasComparar } from "@/utils/dias.utils.js";

export default {
  components: {
    VueQr,
    Impresion,
    Contable,
    BuscarPedidoDialog,
    GenerandoCatalogo,
    DevolucionConfirmarDialog,
    KeyboardCompletoBottom,
    panelLateral,
    panelPedidosInternos,
    footerComponent,
    notificacionDialog,
    eleccionUsuarioDialog,
    EleccionUsuarioAdminAccionesDialog,
    cargandoLazy,
    CobrarDialog,
    ClienteDialog,
    DevolucionDialog,
    anadirDialogo,
    calendarioDialogo,
    infoProductoDialogo,
    zCierreInicio,
    zCierreFin,
    SalidaDineroDialog,
    InternosDialog,
    ProductosDialog,
    CashguardDialog,
    CashguardBottom
  },
  data() {
    return {
      // tab: 0,
      menuUsuario: false,
      loadingNeo: false,
      estado: {
        loading: false,
      },
      menuLateral: false,
      general: true,
      online: true,
      recoger: true,
      menuNeo: false,
      menuDirectorio: false,
      tiempoForzadoCierreDialog: false,
      tiempoForzadoCierreModo: null, //domicilio, recoger, online
      tiempoForzadoCierreEleccion: null, //el tiempo elegido
      checkboxFunEats: true,
      checkboxJustEat: false,
      checkboxUberEats: false,
      checkboxGlovo: false,
      checkboxMesaLibre: true,
      checkboxMesaOcupada: false,
      agregadores: [
        {
          title: "Fun Eats",
          src: "/img/fondoFichaFunEats.png",
          color: "#56a7a8",
        },
        {
          title: "Glovo",
          src: "/img/fondoFichaGlovo.png",
          color: "#f9c52e",
        },
        {
          title: "Just Eat",
          src: "/img/fondoFichaJustEat.png",
          color: "#f27700",
        },
        {
          title: "Uber Eats",
          src: "/img/fondoFichaUberEats.png",
          color: "#4fc83d",
        },
      ],
      // de panelLateral.vue
      loadingZ: false,
      cargandoRecogidaActivada: false,
      cargandoDomicilioActivado: false,
      cargandoTiempoDomicilio: false,
      cargandoTiempoRecogida: false,
      tiempoBloqueo: 2000,
      dialogoSoporte: false,
      dialogoManual: false,
      // hasta aquí panelLateral.vue
    };
  },
  watch: {
    menuLateral(v) {

    },
    tab(newV, oldV) {
      if (newV == this.modosMesas.length + 1) {
        this.actualizarVtab();
      }

      //ultimo pedido
    },
    pistolaTextoDefinitivo(v) {
      if (v.length > 0 && !this.$store.state.pedidos.pedidoDialog) {
        this.buscarPorCodigo(v)
          .then(() => {
            // this.$store.commit("setPistolaTextoDefinitivo", "");
          })
          .finally(() => {
            this.$store.commit("setPistolaTextoDefinitivo", "");
          });
      } else {
      }
      // this.$store.commit("setPistolaTextoDefinitivo", "");
    },
    // de panelLateral.vue
    tiempoDomicilio: function (newVal, oldVal) {
      let _vue = this;

      if (!this.cargandoTiempoDomicilio) {
        this.cargandoTiempoDomicilio = true;

        setTimeout(function () {
          _vue.setTiempoRecogida(_vue.tiempoRecogida);
          _vue.setTiempoDomicilio(_vue.tiempoDomicilio);
          _vue.cargandoTiempoDomicilio = false;
        }, this.tiempoBloqueo);
      }
    },
    tiempoRecogida: function (newVal, oldVal) {
      let _vue = this;

      if (!this.cargandoTiempoRecogida) {
        this.cargandoTiempoRecogida = true;
        setTimeout(function () {
          _vue.setTiempoRecogida(_vue.tiempoRecogida);
          _vue.setTiempoDomicilio(_vue.tiempoDomicilio);
          _vue.cargandoTiempoRecogida = false;
        }, this.tiempoBloqueo);
      }
    },
    // hasta aquí panelLateral.vue
    tiempoForzadoCierreDialog(v) {
      if (!v) {
        if (this.tiempoForzadoCierreEleccion == null) {
          this.$forceUpdate();
        }
      }
    },
  },
  computed: {
    pedidoEditandoObj: {
      get() {
        return this.$store.state.pedidos.pedidoEditandoObj;
      },
      set(v) {
        this.$store.commit("pedidos/setPedidoEditandoObj", v);
      },
    },
    tab: {
      get() {
        return this.$store.state.tab;
      },
      set(v) {
        this.$store.commit("setTab", v);
      },
    },
    totalZ() {
      if (this.$store.state.zcierreResumen.cobrados) {
        return this.$store.state.zcierreResumen &&
          this.$store.state.zcierreResumen.cobrados.totales.total
          ? mostrarMoneda(
            this.$store.state.zcierreResumen.cobrados.totales.total
          )
          : false;
      }
    },
    // de panelLateral.vue
    tiempoDomicilio: {
      get() {
        return this.$store.state.tiempoDomicilio;
      },
      set(v) {
        this.$store.commit("setTiempoDomicilio", v);
      },
    },
    tiempoRecogida: {
      get() {
        return this.$store.state.tiempoRecogida;
      },
      set(v) {
        this.$store.commit("setTiempoRecogida", v);
      },
    },
    // hasta aquí panelLateral.vue
    ...mapState(["pistolaTextoDefinitivo"]),
    ...mapState({
      restObjBruto: (state) => state.restauranteObj,
      negocioObj: (state) => state.negocioObj,
      isLoaded: (state) => state.loaded,
    }),
    modosMesas() {
      return this.$store.state.datosTpv.modos
        .filter((m) => !!m.tipoModo)
        .map((m) => {
          var link = "";
          switch (m.tipoModo) {
            case "domicilio":
              link = "/pedidos/domicilio/" + m.id;
              break;
            case "recoger":
              link = "/pedidos/recoger/" + m.id;
              break;
            case "mostrador":
              link = "/pedidos/mostrador/" + m.id;
              break;
            case "mesas":
              link = "/mesas/" + m.id;
              break;
            case "gofo":
              link = "/pedidos/gofo/" + m.id;
              break;
          }
          return {
            ...m,
            enlace: link,
          };
        });
    },
    abrirDialogoAnadir: {
      get() {
        return this.$store.state.pedido.pedidoDialog;
      },
      set(v) {
        this.$store.commit("pedidos/setPedidoDialog", v);
      },
    },
    usuarioSeleccionado: {
      get() {
        return this.$store.state.usuarios.usuarioActual;
      },
      set(v) { },
    },
    fechaNeo() {
      return this.restObjBruto && this.restObjBruto.fechaActualizacionNeo
        ? moment(this.restObjBruto.fechaActualizacionNeo.toDate()).format(
          "HH:mm DD-MM-YYYY"
        )
        : "";
    },
    estadoDomicilio: {
      get() {
        return this.$store.state.domicilioActivado;
      },
      set(v) { },
    },
    estadoRecoger: {
      get() {
        return this.$store.state.recogidaActivada;
      },
      set(v) { },
    },
    estadoGeneral: {
      get() {
        return this.estadoDomicilio || this.estadoRecoger;
      },
      set(v) { },
    },
    horariosDomicilio() {
      const a = arrayHorariosRest(this.restObj);
      var items = "";
      if (Array.isArray(a) && Array.isArray(a[0])) {
        var items = a[0].map((rango) => rango.inicio + " - " + rango.fin);
      }

      return items;
    },
    horariosRecoger() {
      const a = arrayHorariosRest(this.restObj);
      var items = "";
      if (Array.isArray(a) && Array.isArray(a[1])) {
        var items = a[1].map((rango) => rango.inicio + " - " + rango.fin);
      }
      return items;
    },
    domicilioAbierto() {
      return this.restObj.horariosComputados[0];
    },
    recogidaAbierta() {
      return this.restObj.horariosComputados[1];
    },

    restObj() {
      return {
        ...this.restObjBruto,
        modoHorarioRecogerTiempoMostrar: moment
          .unix(this.restObjBruto.modoHorarioRecogerTiempo)
          .format("HH:mm"),
        modoHorarioDomicilioTiempoMostrar: moment
          .unix(this.restObjBruto.modoHorarioDomicilioTiempo)
          .format("HH:mm"),
      };
    },
    nombre() {
      return this.restObj.nombre;
    },
    horariosComputados() {
      return this.restObj.horariosComputados;
    },
  },
  methods: {
    abrirBuscarPedido() {
      this.$store.commit('pedidos/SET_BUSCAR_PEDIDO_DIALOG', true)
    },
    async cobrarSinProducto() {
      let modo = this.modosMesas.find((m) => m.tipoModo == "mostrador");
      if (modo) {
        this.$store.commit("pedidos/setPedidoEditandoObj", {
          ...this.pedidoEditandoObj,
          canalVenta: "tpv",
        });
        this.pedidoEditandoObj = {
          ...this.pedidoEditandoObj,
          modo:
            this.pedidoEditandoObj && this.pedidoEditandoObj.modo
              ? this.pedidoEditandoObj.modo
              : null,
          id: null,
          cuentaTpv: this.$store.state.auth.user.email,
          copyCuentaTpv: {
            email: this.$store.getters["cuenta"].email,
            nombre: this.$store.getters["cuenta"].nombre,
          },
          fechaInicio: new Date(),
          fechaServidor: firebase.firestore.Timestamp.now(),
          zcierre: this.$store.state.zcierre,
          xcierre: this.$store.state.xcierre,
          usuarioTpv: this.$store.state.usuarios.usuarioActual,
          comentarioPedidoTpv: "",
          nombrePersonalizadoTpv: "",
          cobradoDesglose: [],
          cobradoProgramado: [],
          copyUsuarioTpv: {
            nombre: this.$store.state.usuarios.usuarioActualObj.nombre,
          },
          historial: [
            {
              fecha: moment().unix(),
              mensaje: "comienzo pedido directo",
              usuario: this.$store.state.usuarios.usuarioActual,
            },
          ],
          estado: "tpv-realizando",
          canalVenta: "tpv",
          precioTotal: 0,
          impuestosTotal: 0,
          numPedidoRest: null,
          numPedidoRestDia: null,
          numPedidoRestDiaModo: null,
          negocio: this.$store.state.restauranteObj.negocio,
          restaurante: this.$store.state.restauranteObj.id,
          // restaurante: restSinNegocio(this.$store.state.restauranteObj),
          copyRest: {
            nombre: this.$store.state.restauranteObj.nombre
              ? this.$store.state.restauranteObj.nombre
              : "",
            cif: this.$store.state.restauranteObj.cif
              ? this.$store.state.restauranteObj.cif
              : "",
            telefono: this.$store.state.restauranteObj.telefono
              ? this.$store.state.restauranteObj.telefono
              : "",
            direccion: this.$store.state.restauranteObj.direccion
              ? this.$store.state.restauranteObj.direccion
              : "",
            tiempoDomicilio:
              this.$store.state.restauranteObj &&
                this.$store.state.restauranteObj.tiempoDomicilio
                ? this.$store.state.restauranteObj.tiempoDomicilio
                : null,
            tiempoRecogida:
              this.$store.state.restauranteObj &&
                this.$store.state.restauranteObj.tiempoRecogida
                ? this.$store.state.restauranteObj.tiempoRecogida
                : null,
            confGeneral: {
              zonaHoraria:
                this.$store.state.restauranteObj.confGeneral &&
                  this.$store.state.restauranteObj.confGeneral.zonaHoraria
                  ? this.$store.state.restauranteObj.confGeneral.zonaHoraria
                  : null,
            },
          },
          copyNegocio: {
            nombre: this.$store.state.negocioObj.nombre,
          },
          productos: [],
          menus: [],
        };
        if (!!this.pedidoEditandoObj.direccion) {
          this.pedidoEditandoObj.direccion = this.pedidoEditandoObj.direccion;
        }
        this.$store.commit(
          "pedidos/setPedidoEditandoObj",
          this.pedidoEditandoObj
        );
        this.$store.commit(
          "pedidos/setPedidoEditando",
          this.pedidoEditandoObj.id
        );
        this.$store.commit("pedidos/setPedidoEditandoObjValor", {
          key: "modo",
          value: modo.tipoModo,
        });
        this.$store.commit("pedidos/setPedidoEditandoObjValor", {
          key: "modoId",
          value: modo.id,
        });
        this.$store.commit("pedidos/setPedidoEditandoObjValor", {
          key: "modoTexto",
          value: modo.nombre,
        });
        this.$store.commit("pedidos/setPedidoEditandoObjValor", {
          key: "modoCopy",
          value: modo,
        });

        this.$store.commit("pedidos/setPedidoEditandoObjValor", {
          key: "uid",
          value: "0",
        });
        this.$store.commit("pedidos/setPedidoEditandoObjValor", {
          key: "copyUser",
          value: {
            displayName: "Contado",
          },
        });
        this.$store.commit("pedidos/setModoPantalla", "pedidoCarrito");
        this.$store.commit("pedidos/setPedidoDialog", true);
        this.$store.commit("pedidos/SET_IMPRIMIR_DESPUES_COBRAR", false);

        await this.$store
          .dispatch(
            "pedidos/addNuevoPedido",
            this.$store.state.pedidos.pedidoEditandoObj
          )
          .then((r) => {

            this.creando = false;

            this.$store.commit("pedidos/setPedidoEditando", r[0].id);
            this.$store.commit("pedidos/setPedidoEditandoObjValor", {
              key: "id",
              value: r[0].id,
            });
            this.$store.commit("pedidos/setPedidoEditandoObjValor", {
              key: "numPedidoRest",
              value: r[0].numPedidoRest,
            });
            this.$store.commit("pedidos/setPedidoEditandoObjValor", {
              key: "numPedidoRestDia",
              value: r[0].numPedidoRestDia,
            });
            this.$store.commit("pedidos/setPedidoEditandoObjValor", {
              key: "numPedidoRestDiaModo",
              value: r[0].numPedidoRestDiaModo,
            });
            this.$store.commit("pedidos/setPedidoEditandoObjValor", {
              key: "numPedidoRestDiaModoMostrar",
              value: r[0].numPedidoRestDiaModoMostrar,
            });

            return this.$store.dispatch(
              "pedidos/savePedido",
              this.pedidoEditandoObj
            );
          });
        let p = this.$store.getters["productos/PRODUCTOS_CATALOGO"].find(
          (p) => p.prodLibre
        );

        if (p) {
          p.nombre = mostrarIdioma(p);
          var prodLibre = {};
          var idLibre = p.id + "_" + moment().unix();
          prodLibre.id = idLibre;
          prodLibre.idLibre = p.id;
        }
        this.$store.dispatch("pedidos/addProducto", {
          producto: { ...p, ...prodLibre },

          cantidad: 1,
        });
        let prodEditar = {
          ...p,
          id: idLibre,
          opciones: [],
          cantidad: 1,
          precioProductoTotalUnitario: parseFloat(p.precio),
          precioProductoTotal: parseFloat(p.precio),
          impuesto: p.impPorcentaje,
        };

        this.$store.commit("pedidos/setEditarProductoObj", prodEditar);
      }
    },
    salidaDinero() {
      this.$store.commit("setSalidaDineroDialog", true);
    },

    ultimopedido() {
      this.$store.dispatch("pedidos/ultimopedidoMostrarCobrar").then((r) => {
        if (r) {
          this.$store.commit("pedidos/setCobrarDialog", true);

          this.pedidoEditando = r;
          this.$store.dispatch("pedidos/setPedidoObj", r);
        }
      });
    },
    buscarPorCodigo(v) {
      if (v.length > 2) {
        var f = new Promise((resolve) => {
          let res = this.$store.getters["productos/PRODUCTOS_CATALOGO_DEFECTO"]
            .filter((p) => {
              return (
                !!p.codigoLector &&
                p.codigoLector.toUpperCase().includes(v.toUpperCase())
              );
            })
            .map((p) => {
              return {
                ...p,
                nombre: mostrarIdioma(p),
                precioMostrar: p.precio ? mostrarMoneda(p.precio) : "0.00",
              };
            });
          resolve(res);
        });
        return f.then((r) => {
          if (r[0]) {
            this.$store.commit("setInfoProductoObj", r[0]);
            this.$store.commit("setInfoProductoDialogo", true);
          }
        });
        this.loadingBuscar = true;
      } else {
        return Promise.resolve();
        // this.resultadosBusqueda = [];
      }
    },
    cerrarDia() {
      this.$store.commit("setZCierreFinDialog", true);
      // this.$store.dispatch("finZCierre");
    },
    // de panelLateral.vue
    ...mapActions({
      setRecogidaActivada: "setRecogidaActivada",
      setDomicilioActivado: "setDomicilioActivado",
      setTiempoDomicilio: "setTiempoDomicilio",
      setTiempoRecogida: "setTiempoRecogida",
    }),
    abrirCajon() {
      let _vm = this;
      _vm.loadingZ = true;
      this.$store
        .dispatch("abrirCajon")
        .then((r) => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Cajón abierto",
          });
        })
        .catch((e) => {
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al imprimir el Z: " + e,
          });
        })
        .finally(() => {
          _vm.loadingZ = false;
        });
    },
    imprimirz() {
      let _vm = this;
      _vm.loadingZ = true;
      this.$store
        .dispatch("calcularCierre")
        .then(() => {
          return this.$store.dispatch("imprimirz");
        })
        .then((r) => {
          /*this.$store.commit("snackbar/setMensajeSuccess", {
          msj: "Se ha mandado a imprimir el Z",
        });*/
        })

        .finally(() => {
          _vm.loadingZ = false;
        });
    },
    async imprimirzAyer() {
      let _vm = this;
      _vm.loadingZ = true;
      const fechaMoment = moment().subtract(1, "day").clone();
      const fechaMomentEnviar = moment().subtract(1, "day").clone();

      var pedidos = await this.$store.dispatch(
        "pedidos/getPedidosOtroDia",
        parDiasComparar(fechaMoment)
      );
      this.$store
        .dispatch("calcularCierre", pedidos)
        .then(() => {
          return this.$store.dispatch("imprimirzAyer", {
            pedidos: pedidos,
            fecha: fechaMomentEnviar,
          });
        })
        .then((r) => {
          /*this.$store.commit("snackbar/setMensajeSuccess", {
          msj: "Se ha mandado a imprimir el Z",
        });*/
        })

        .finally(() => {
          _vm.loadingZ = false;
        });
    },
    sumarRestar(operacion, tipo) {
      let minutos = 5;
      switch (tipo) {
        case "reparto":
          operacion == "suma"
            ? (this.tiempoDomicilio += minutos)
            : this.tiempoDomicilio - minutos >= 0
              ? (this.tiempoDomicilio -= minutos)
              : null;

          break;
        default:
          operacion == "suma"
            ? (this.tiempoRecogida += minutos)
            : this.tiempoRecogida - minutos >= 0
              ? (this.tiempoRecogida -= minutos)
              : null;

          break;
      }
    },
    // hasta aquí panelLateral.vue
    actualizarNeoRestaurante() {
      var _vm = this;
      _vm.loadingNeo = true;

      this.$store
        .dispatch("neo/actualizarNeoRestaurante")
        .then(() => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Productos sincronizados",
          });
        })
        .catch((e) => {
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al sincronizar " + e,
          });
        })
        .finally(() => {
          _vm.loadingNeo = false;
        });
    },
    cambiarEstadoDomicilio(v) {
      var _vm = this;
      this.$store.commit("setDomicilioActivado", v);
      this.$store
        .dispatch("setDomicilioActivado", {
          v: v,
          t: _vm.tiempoForzadoCierreEleccion,
        })
        .then(() => {
          this.$store.commit("setDomicilioActivado", v);
        })
        .catch((e) => { })
        .finally(() => {
          _vm.estado.loading = false;
        });
    },
    cambiarEstadoRecoger(v) {
      var _vm = this;
      this.$store.commit("setRecogidaActivada", v);
      this.$store
        .dispatch("setRecogidaActivada", {
          v: v,
          t: _vm.tiempoForzadoCierreEleccion,
        })
        .then(() => {
          this.$store.commit("setRecogidaActivada", v);
        })
        .catch((e) => { })
        .finally(() => {
          _vm.estado.loading = false;
        });
    },
    cambio(v) {
      this.tiempoForzadoCierreModo = v;
      var _vm = this;
      if (
        (v.includes("domicilio") && this.estadoDomicilio) ||
        (v.includes("recoger") && this.estadoRecoger)
      ) {
        // va a cerrar
        this.tiempoForzadoCierreEleccion = null;
        this.tiempoForzadoCierreDialog = true;
      } else {
        this.tiempoForzadoCierreEleccion = null;
        if (v.includes("domicilio")) {
          _vm.cambiarEstadoDomicilio(true);
        }
        if (v.includes("recoger")) {
          _vm.cambiarEstadoRecoger(true);
        }
      }
    },
    /* ...mapActions({
    logout: "auth/firebaseLogout",
  }), */
    volver() {
      this.$router.go(-1);
    },
    elegirTiempoCierre(t) {
      this.tiempoForzadoCierreEleccion = t;
      this.tiempoForzadoCierreModo.forEach((m) => {
        if (m == "domicilio") this.cambiarEstadoDomicilio(false);
        if (m == "recoger") this.cambiarEstadoRecoger(false);
      });
      this.tiempoForzadoCierreModo = [];
      this.tiempoForzadoCierreDialog = false;
    },
    actualizarVtab() {

      let path = this.$route.path;
      switch (path) {
        case "/dashboard":
          this.tab = this.modosMesas.length + 3;
          break;
        case "/busquedapedidos":
          this.tab = this.modosMesas.length + 2;
          break;
        default:
          let fI = this.modosMesas.findIndex(
            (m) => m.enlace == this.$route.path
          );
          this.tab = fI + 1;
      }
    },
    abrirCashguard() {
      this.$store.commit("alternarUsoCashguard");
      // this.$store.commit("cashguard/SET_CASHGUARD_DIALOG", true);
    },
  },
  mounted() {
    if (this.$store.getters['auth/isTpv']) {
      this.actualizarVtab();
    }

    this.$store.dispatch("cargaDespuesInicio");
    this.$store.commit("setModoFuncionamiento", "tpv");
  },
};
</script>

<style lang="scss">
.fe--inicio-btn,
.usuarios-btn {
   > .v-btn__content {
    max-width: 100%;
  }
}

.subheader-nav--sticky {
  position: sticky;
  top: 78px;
  z-index: 5;
}

.border-primary.hora-cabecera {
  padding-top: 3px;
  padding-bottom: 3px;
  border: solid 1px #00f4d9 !important;
}

.modos-tabs {
  a {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 90px;
    height: 100%;
    text-align: center;
    text-decoration: none;

     > span {
      width: 100%;
    }
  }

  /* .v-tab--active {
    &::before {
      opacity: .1 !important;
      background-color: black;
    }
  } */
}

/** Fix de wordbreak en v-card-title **/
/* .v-card__text, */
.v-card__title {
  word-break: normal;

  /* maybe !important  */
  &.caption {
    line-height: 1.4;
  }
}
</style>
